import { render, staticRenderFns } from "./FormBusqueda.vue?vue&type=template&id=11896578&scoped=true"
import script from "./FormBusqueda.vue?vue&type=script&lang=js"
export * from "./FormBusqueda.vue?vue&type=script&lang=js"
import style0 from "./FormBusqueda.vue?vue&type=style&index=0&id=11896578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11896578",
  null
  
)

export default component.exports